module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Our agencies"},"fr":{"title":"Nos agences"},"de":{"title":"Händlersuche"}}')
  delete Component.options._Ctor
}
